import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

import axios from 'axios'
import { geojsonToArcGIS } from '@esri/arcgis-to-geojson-utils';
import './Eierrapport.scss'

class Eierrapport extends Component {
    state = {
        isVisible: false,
        isPolygonActive: false,
        isPolylineActive: false,
        isJsonActive: false,
        isJsonValid: false,
        isWaitingForMapClick: false,
        isCompleted: false,
        isLoading: false,
        hasError: false,
        selectedGeometry: null,
        sketchViewModel: null
    }

    UNSAFE_componentWillMount = () => 
    {
        this.props.expand.watch("expanded", (newValue, oldValue, property, object) => {
            if (!newValue) {
                this.props.graphicsLayer.removeAll();
                this.setState({ isVisible:false, isPolygonActive: false, isPolylineActive: false, isJsonActive: false })
                return
            }

            this.props.sketchViewModel.on("create", event => {
                if (event.state === "start") {
                    this.setState({isWaitingForMapClick: false})
                }

                if (event.state === "complete") {
                    this.setState({isCompleted: true, isPolygonActive: false, isPolylineActive: false, isJsonActive: false, selectedGeometry: event.graphic.geometry })
                }

            })
        })
    }

    drawPolyline = () => {
        this.props.graphicsLayer.removeAll();                    
        this.props.sketchViewModel.create("polyline");
        this.setState({ hasError: false, isPolygonActive: false, isPolylineActive: true, isJsonActive: false, isWaitingForMapClick: true, isCompleted: false })

    }

    drawPolygon = () => {
        this.props.graphicsLayer.removeAll();                            
        this.props.sketchViewModel.create("polygon");

        this.setState({ hasError: false, isPolygonActive: true, isPolylineActive: false, isJsonActive: false, isWaitingForMapClick: true, isCompleted: false })
    }

    activateJson = () => {
        this.setState({ hasError: false, isPolygonActive: false, isPolylineActive: false, isJsonActive: true, isJsonValid: false, isWaitingForMapClick: false, isCompleted: false })
    }

    drawGeoJson = () => {
        let graphic = null;

        if (this.state.selectedGeometry.type === "polygon") {
            graphic = this.createPolygonGraphic(this.state.selectedGeometry)
        }

        if (this.state.selectedGeometry.type === "polyline") {
            graphic = this.createPolylineGraphic(this.state.selectedGeometry)
        }

        if (this.state.selectedGeometry.type === "point") {
            graphic = this.createPointGraphic(this.state.selectedGeometry)
        }

        this.props.graphicsLayer.removeAll();
        this.props.graphicsLayer.add(graphic)
        this.props.view.goTo({target: this.state.selectedGeometry, zoom: 16})
        this.setState({isCompleted: true, isPolygonActive: false, isPolylineActive: false, isJsonActive: false })
    }

    createPolygonGraphic = (geometry) => {
        return {
            geometry: geometry,
            symbol: {
                type: "simple-fill",
                color: [ 0, 255, 255, 0.2 ],
                outline: {
                  color: [ 0, 255, 255 ],
                  width: 2
                }
            }
        }
    }

    createPolylineGraphic = (geometry) => {
        return {
            geometry: geometry,
            symbol:  {
                type: "simple-line",
                color: [ 0, 255, 255 ],
                width: 2
              }
        }
    }

    createPointGraphic = (geometry) => {
        return {
            geometry: geometry,
            symbol:  {
                type: "simple-marker",
                color: [ 0, 255, 255 ]
              }
        }
    }

    extractGeometry = (geometry) => {
        try {
            return geometry.features[0].geometry;
        } catch (error) {
            return geometry;
        }
    }

    onGeoJsonChanged = (e) => {
        const outSpatialReference = new this.props.SpatialReference({wkid: 25833})
        const jsonString = e.target.value;
        try {
            const geoJson = JSON.parse(jsonString);
            const geoJsonGeometry = this.extractGeometry(geoJson);
            const esriGeometryJson = geojsonToArcGIS(geoJsonGeometry);
            const esriGeometry = this.props.jsonUtils.fromJSON(esriGeometryJson);
            const isValid = esriGeometry.type === "polygon" || esriGeometry.type === "polyline" || esriGeometry.type === "point";
            if (esriGeometry && isValid) {
                this.props.projection.load().then(() => {
                    let projectedEsriGeometry = this.props.projection.project(esriGeometry, outSpatialReference)
                    if (projectedEsriGeometry) {
                        { this.setState({isJsonValid: true, selectedGeometry: projectedEsriGeometry}) }
                        return
                    }
            })}
            this.setState({isJsonValid: false, selectedGeometry: null})
        } catch (error) {
            this.setState({isJsonValid: false, selectedGeometry: null})
        }
    }

    downloadCsv = () => {
        this.downloadEierrapport("csv");
    }

    downloadPdf = () => {
        this.downloadEierrapport("pdf");
    }

    downloadEierrapport = format => {
        this.setState({isLoading: true})
        axios.post(`${this.props.settings.baseUrl}/api/eier/rapport?token=${this.props.token}`,  {
            format: format,
            geometry: this.state.selectedGeometry,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: "blob"
        })
        .then(({ data }) => {
            if (data.type == "text/plain")
            {
                this.setState({hasError: true, isLoading: false, isPolygonActive: false, isPolylineActive: false, isJsonActive: false, isCompleted: false})
                return;
            }

            const url = window.URL.createObjectURL(data);

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Eierrapport.${format}`)
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            this.setState({isLoading: false, isPolygonActive: false, isPolylineActive: false, isJsonActive: false, isCompleted: false})
        }).catch((errr) => {

            this.setState({hasError:true, isLoading: false, isPolygonActive: false, isPolylineActive: false, isJsonActive: false, isCompleted: false})
        })
    }

    render() {
        const { t } = this.props;
        return (
            <div className="eierrapport esri-widget">
                <div className="tool-list">
                    <div className="tooltip-content">{t('velggeometri')}</div>
                    <button className={`esri-widget--button ${this.state.isPolygonActive ? "tool-active": ''}`} onClick={this.drawPolygon}>
                        <span aria-hidden="true" className="esri-icon esri-icon-polygon"></span>
                    </button>

                    <button className={`esri-widget--button ${this.state.isPolylineActive ? "tool-active": ''}`} onClick={this.drawPolyline}>
                        <span aria-hidden="true" className="esri-icon esri-icon-polyline"></span>
                    </button>

                    <button className={`esri-widget--button ${this.state.isJsonActive ? "tool-active": ''}`} onClick={this.activateJson}>
                        <span aria-hidden="true" className="esri-icon esri-icon-attachment"></span>
                    </button>
                </div>
                { this.state.isJsonActive && <div>
                    <button className={`description esri-button esri-button-primary ${this.state.isJsonValid ? '': "esri-button--disabled"}`} disabled={!this.state.isJsonValid} onClick={this.drawGeoJson}>{t('geojson')}</button>
                    <textarea onChange={this.onGeoJsonChanged} />
                </div> }
                { this.state.isWaitingForMapClick && <div className="description">{t('klikkikart')}</div>}
                { this.state.isCompleted && !this.state.isLoading &&
                <div className="description">
                    <button className="esri-button esri-button-primary" onClick={this.downloadCsv}>{t('lastnedcsv')}</button>
                    <button className="esri-button esri-button-primary" onClick={this.downloadPdf}>{t('lastnedpdf')}</button>
                </div>}
                { this.state.isLoading && <div className="description"><div className="spinner"><i className="fa fa-fw fa-spinner fa-spin"></i></div></div>}
                { this.state.hasError && <div className="description">{t('eierrapportfeil')}</div>}
            </div>
        )
        
    }
}

export default withTranslation('common')(Eierrapport)